import { post } from './http';

export const add = async data => {
    const response = await post('/api/cart/add', { articles: data });
    return response.json();
}

export const reorder = async (orderId) => {
    const response = await post('/api/cart/reorder', { orderId });
    return response.json();
}